import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38268d44&scoped=true&"
import script from "./switchButton.js?vue&type=script&lang=js&"
export * from "./switchButton.js?vue&type=script&lang=js&"
import style0 from "./switchButton.scss?vue&type=style&index=0&id=38268d44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38268d44",
  null
  
)

export default component.exports